var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"disabled":_vm.disabled,"items":_vm.groupedSlates,"no-data-text":"No slates are currently available for this date","item-text":_vm.displaySlate,"item-value":"id","label":"Select Slate","menu-props":{
            closeOnClick: true,
            closeOnContentClick: true,
        },"filled":"","return-object":""},model:{value:(_vm.slateValue),callback:function ($$v) {_vm.slateValue=$$v},expression:"slateValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }